// Funnel Components
import AlgoliaSearchBox from '../components/AlgoliaSearchBox';
import UpdatePaymentForm from '../components/forms/UpdatePaymentForm';
import Navigation from '../components/Navigation';
import NavigationDrawer from '../components/NavigationDrawer';
import MobileHomeLink from '../components/NavigationDrawer/MobileHomeLink';
import ProPage from '../pages/ProPage';
import HomePage from '../pages/HomePage';
import { Footer } from '@alltrails/shared-components';
import { BranchAppText } from '../application/javascripts/react_components/branch/branch_app_text';
import { GiftFlow } from '../components/GiftFlow/GiftFlow/GiftFlow';
import GlobalActions from '../components/GlobalActions';
import { MobileRoadblock } from '../application/javascripts/react_components/branch/mobile_roadblock';
import LoginForm from '../components/forms/LoginForm';
import ProfileSlidingTabs from '../components/profile/ProfileSlidingTabs';
import { QuoteRotator } from '../application/javascripts/react_components/quote_rotator';
import RedemptionPage from '../components/RedemptionPage';
import { RoadblockedAnchor } from '../application/javascripts/react_components/branch/roadblocked_anchor';
import SignUpForm from '../components/forms/SignUpForm';

require('@alltrails/shared-components/dist/main.css');
const ReactRailsUJS = require('react_ujs');

const context = {
  AlgoliaSearchBox,
  BranchAppText,
  UpdatePaymentForm,
  GiftFlow,
  GlobalActions,
  HomePage,
  Footer,
  LoginForm,
  MobileRoadblock,
  MobileHomeLink,
  Navigation,
  NavigationDrawer,
  ProPage,
  QuoteRotator,
  RedemptionPage,
  RoadblockedAnchor,
  ProfileSlidingTabs,
  SignUpForm
};
ReactRailsUJS.getConstructor = className => {
  return context[className];
};
